import { routerStyxie } from '@/router/styxieBridge'

Styxie.Initializers.GmbBulkPosts = routerStyxie({ actions: ['index', 'show']})
